import React from "react";
import cn from "classnames";
import { StarButton, Button, PollItem, SliceConfig } from "~components";
import { useInView } from "react-intersection-observer";
import { Link } from "gatsby";
import { useBreakpoints } from "~hooks";
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "./styles.module.scss";

const Media = ({ mediaType, image, video, productLink }) => (
  <>
    {mediaType === `image` && (
      <GatsbyImage
        image={image?.asset?.gatsbyImageData}
        alt={image?.asset?.altText || ``}
      />
    )}

    {mediaType === `video` && (
      <video
        muted
        autoPlay
        loop
        playsInline
        className={styles.video}
        src={video?.asset?.url}
      />
    )}

    {productLink && (
      <Link
        className={styles.productLink}
        to={`/products/${productLink?.Product?.store?.slug?.current}`}
      >
        <StarButton light>{productLink?.title}</StarButton>
      </Link>
    )}
  </>
);

const PollResults = ({
  header,
  image,
  video,
  mediaType,
  mediaOnRight,
  productLink,
  textBlock,
  cta,
  pollItems,
  sliceConfig
}) => {
  const bp = useBreakpoints();

  const { ref, inView } = useInView({
    rootMargin: `-90px`,
    triggerOnce: true
  });

  return (
    <SliceConfig config={sliceConfig}>
      <div
        className={cn(styles.flexContainer, {
          [styles.mediaOnRight]: mediaOnRight
        })}
      >
        <div className={styles.leftColumn}>
          <div>
            <h2 className={cn(`h2`, styles.header)}>{header}</h2>
            <div className={styles.mobileMedia}>
              <Media
                mediaType={mediaType}
                image={image}
                video={video}
                productLink={productLink}
              />
            </div>
            {pollItems?.[0] && (
              <div ref={ref} className={styles.pollContainer}>
                {pollItems.map((item, i) => (
                  <div className={styles.pollItem} key={i}>
                    <PollItem
                      itemName={item.itemName}
                      percentage={item.percentage}
                      gradientStartColor={item.gradientStartColor.hex}
                      gradientEndColor={item.gradientEndColor.hex}
                      animate={inView}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
          <div>
            {textBlock?.header && (
              <h3 className={cn(`h4`, styles.textBlockHeader)}>
                {textBlock.header}
              </h3>
            )}
            {textBlock?.text && (
              <p className={cn(`b2`, styles.textBlockText)}>{textBlock.text}</p>
            )}
            {cta?.title && (
              <Button
                className={styles.cta}
                fluid={!bp.largeTablet}
                variant="secondary"
                to={cta.reference.slug.current}
              >
                {cta.title}
              </Button>
            )}
          </div>
        </div>
        <div className={styles.desktopMedia}>
          <Media
            mediaType={mediaType}
            image={image}
            video={video}
            productLink={productLink}
          />
        </div>
      </div>
    </SliceConfig>
  );
};

export default PollResults;
